/**
 * useActiveAdminMenuLayout — query GET /api/admin/menu/layouts/active (ADR-0034).
 *
 * Resolver: (0) jawny wybór wbudowanego menu ITE (admin_user_menu_preferences.layout_id
 * = NULL, migracja 0074) → (1) admin preference → (2) role-based assignment →
 * (3) default layout → null. Backend zwraca `{layout: null}` (200) gdy Level 0 jest
 * jawnym wyborem LUB gdy żaden z poziomów 1-3 nie match'uje — w obu przypadkach
 * frontend (AdminSidebar) interpretuje to jako fallback B.1 → renderuj statyczny ADMIN_MENU.
 *
 * Używane przez:
 *   - `AdminSidebar` — conditional render custom layout vs statyczny fallback.
 *   - `AdminMenuBuilderPage` — initial hierarchy do edycji (przez MenuBuilderShell).
 *
 * staleTime 60s — admin zobaczy zmiany layoutu po refresh / next nawigacji.
 */

import type { AdminMenuLayoutDto } from '@saas/shared';
import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

export const ACTIVE_ADMIN_MENU_LAYOUT_QUERY_KEY = ['admin', 'menu', 'layouts', 'active'] as const;

export interface ActiveAdminMenuLayoutResponse {
  layout: AdminMenuLayoutDto | null;
}

export function useActiveAdminMenuLayout(opts?: { enabled?: boolean }) {
  return useQuery<ActiveAdminMenuLayoutResponse>({
    queryKey: ACTIVE_ADMIN_MENU_LAYOUT_QUERY_KEY,
    queryFn: async () => {
      const res = await api.get<ActiveAdminMenuLayoutResponse>('/admin/menu/layouts/active');
      return res.data;
    },
    enabled: opts?.enabled ?? true,
    staleTime: 60_000,
  });
}
